import {useEffect, useState, useRef} from "react"

const LOCAL_STORAGE_KEY = "uploadedImage";

export const useImageUpload = () => {
        const [selectedImage, setSelectedImage] = useState<string | null>(null);
        const [buttonText, setButtonText] = useState<string>("upload photo");
        const fileInputRef = useRef<HTMLInputElement>(null!);

        useEffect(() => {
            const storedImage = localStorage.getItem(LOCAL_STORAGE_KEY);
            if (storedImage) {
                setSelectedImage(storedImage);
                setButtonText("download photo");
            }
        }, []);

            const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
                const file = event.target.files?.[0];
                if (!file) return;
        
                const reader = new FileReader()
                reader.onload = () => {
                    const imageData = reader.result as string;
                    setSelectedImage(imageData)
                    setButtonText("download photo");
                    localStorage.setItem(LOCAL_STORAGE_KEY, imageData);
                }
                reader.readAsDataURL(file)
            };
        
            const handleDeletePhoto = () => {
                setSelectedImage(null);
                setButtonText("upload photo");
                fileInputRef.current.value = "";
                localStorage.removeItem(LOCAL_STORAGE_KEY);
            };
            return{
                selectedImage,
                setSelectedImage,
                buttonText,
                setButtonText,
                fileInputRef,
                handleImageUpload,
                handleDeletePhoto
            }
};